import { BackButton } from "../../../components/Button/BackButton";
import { Button } from "../../../components/Button";
import { Card } from "../../../components/Card";
import { TierProgressCard } from "./TierProgressCard";
import { TierProgressCardsSkeleton } from "./TierScreenSkeleton";

type TierScreenProps = {
  onCloseTierScreen: () => void;
  tierProgress: any;
  isLoading: boolean;
  isError: boolean;
  isRefetching: boolean;
  onRetry: () => void;
};

export function TierScreen({
  onCloseTierScreen,
  tierProgress,
  isLoading,
  isError,
  isRefetching,
  onRetry,
}: TierScreenProps) {
  const tiers = tierProgress?.tiers ?? [];

  return (
    <Card className="!p-6 max-h-[calc(100vh-100px)] overflow-y-auto">
      <div className="flex justify-center relative">
        <div className="absolute -top-1 left-0">

          <BackButton text="Back" onClick={onCloseTierScreen} />
        </div>
        <div className="flex flex-col gap-1 items-center">
          <span className="text-black text-2xl font-bold">Tier Progression</span>
          <span>See where you are and what comes next in the program</span>
        </div>
      </div>
      <div className="flex items-stretch mt-6 gap-6 w-[calc(100vw-400px)] py-4 overflow-x-auto">
        {isLoading ? (
          <TierProgressCardsSkeleton />
        ) : isError ? (
          <div className="flex flex-col items-center justify-center gap-3 w-full min-h-[200px]">
            <span className="text-black text-base">Unable to load tier progression. Please try again.</span>
            <Button variant="outline" onClick={onRetry} loading={isRefetching}>
              Try again
            </Button>
          </div>
        ) : tiers.length === 0 ? (
          <div className="flex items-center justify-center w-full min-h-[200px]">
            <span className="text-black text-base">No tier progression data available yet.</span>
          </div>
        ) : (
          tiers.map((tier: any, index: number) => (
            <TierProgressCard
              key={tier.tier}
              index={index}
              isCurrentTier={tier.tier === tierProgress?.current_tier}
              tier={tier}
              currentTier={tierProgress?.current_tier}
              currentSubTier={tierProgress?.current_sub_tier}
            />
          ))
        )}
      </div>
    </Card>
  );
}